<template>
    <div id="main-viewport" style="overflow-y: hidden;">
        <layout :isLoading="isLoading"></layout>
    </div>
</template>

<script>
import Monitor from '@dap/monitor/sdk/index';
import watermark from 'watermark-dom';
import Layout from '@/views/layout/index.vue';

export default {
    components: {
        Layout,
    },
    data () {
        return {
            isLoading: true,
        };
    },
    beforeMounted () {
        window.watermark = watermark;
    },
    mounted () {
        Monitor.init();
    },
};
</script>
